import Vue from 'vue'
import App from './App.vue'
import router from './router'

import axios from 'axios'
import VueAxios from 'vue-axios'


import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

import store from './store/store'


Vue.config.productionTip = false;

Vue.use(VueAxios, axios)

Vue.prototype.http = axios;


Vue.use(require('vue-moment'));
Vue.use(Datetime);



Vue.filter('toCurrency', function (value) {

  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('pt-BR', {
      style: 'decimal',
      minimumFractionDigits: 2
  });
  return formatter.format(value);
});

Vue.filter('toCpfFormatado', function (value) {
               
  return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
});

Vue.filter('toCnpjFormatado', function (value) {
  return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  
});



Vue.prototype.$ss = {};



const vue = new Vue({
  store,
  data: {
    sessao: '',
    loading: false,
    id_filial: 0,
    id_usuario: 0,
    ide : '',
    login: '', 
    sessaoExpirada : false   
  },
  methods : {
    setLoading(loading){
      this.loading = loading;
    },
    isLoading(){
      return this.loading;
    },
    setSessao(sessao){
      this.sessao = sessao;
    },
    getSessao(){
      return this.sessao;
    },
    
    setFilial(filial){
      this.id_filial=filial;
    },
    setUsuario(usuario){
      this.id_usuario = usuario;
    },
    getFilial(){
      return this.id_filial;
    },
    getUsuario(){
      return this.id_usuario;
    },
    setIde(ide){
      this.ide=ide;
    },
    setLogin(login){
      this.login = login;
    },
    getIde(){
      return this.ide;
    },
    getLogin(){
      return this.login;
    },
    getSessaoExpirada(){
      return this.sessaoExpirada;
    },
    setSessaoExpirada(sessaoExpirada){
      this.sessaoExpirada = sessaoExpirada;

    }


  },
  router,
  render: h => h(App)
}).$mount('#app');


router.beforeEach((to, from, next) => {

  if ((from.name === 'Login') &&  (vue.getSessao()==='')){
    next(false);
  } else  if ((to.name !== 'Login') && (vue.getSessao()==='')){   
    next();
    vue.setSessaoExpirada(true);
  } else {
    next();
  }

});
